import { Button } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { ArrowLeft, RotateCcw } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export const ErrorStep = ({ error, onBack }: { error: string; onBack: () => void }) => {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <p className="text-destructive text-sm">{error}</p>
        <div className="flex gap-3">
          <Button variant="bordered" onClick={onBack}>
            <ArrowLeft className="size-4" />
            <Trans>Back</Trans>
          </Button>
          <Button onClick={() => navigate(0)}>
            <RotateCcw className="size-4" />
            <Trans>Retry</Trans>
          </Button>
        </div>
      </div>
    </div>
  )
}
